import { CartesianChartSpecTransformer } from "../cartesian";

import { setDefaultCrosshairForCartesianChart } from "../util";

export class AreaChartSpecTransformer extends CartesianChartSpecTransformer {
    _getDefaultSeriesSpec(spec) {
        return Object.assign(Object.assign({}, super._getDefaultSeriesSpec(spec)), {
            point: spec.point,
            line: spec.line,
            area: spec.area,
            seriesMark: spec.seriesMark,
            activePoint: spec.activePoint,
            sampling: spec.sampling,
            samplingFactor: spec.samplingFactor,
            pointDis: spec.pointDis,
            pointDisMul: spec.pointDisMul,
            markOverlap: spec.markOverlap,
            areaLabel: spec.areaLabel
        });
    }
    transformSpec(spec) {
        super.transformSpec(spec), setDefaultCrosshairForCartesianChart(spec);
    }
}
//# sourceMappingURL=area-transformer.js.map
